import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyDefaultThingsToDoHoneymoon = loadable(
  () => import(/* webpackChunkName: "content/websiteEditorDefaultThingsToDoHoneymoon" */ './DefaultThingsToDoHoneymoon'),
  'DefaultThingsToDoHoneymoon',
);
